const LoadingList = [
    {
        author: "喨哥",
        date: "2018-06-05T16:46:09.000Z",
        text: "給我一瓶酒再給我一支煙",
    },
    {
        author: "諸葛喨",
        date: "2018-06-05T16:46:09.000Z",
        text: "說走就走我有的是時間",

    },
    {
        author: "撒思嘎喨哥",
        date: "2018-06-05T16:46:09.000Z",
        text: "我不想在未來的日子裡依舊哭著無法往前",
    },
]
export default LoadingList


// WEBPACK FOOTER //
// ./src/Lottery/LoadingList.js